import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "OpinionService",
  controller: "ContentCollect",
};

const methods = [
  "GetContentCollect"
 
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};

const ContentCollectApi = ZJApi.defineNewApi("ContentCollectApi", factory);

export default ContentCollectApi;
